module.exports = __webpack_public_path__ + "img/071.5fd926df.png";